const styles = (theme) => ({
  headerSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  dollySectionTitle: {
    fontSize: theme.textFontSize,
    textTransform: "uppercase",
    textAlign: "left",
    color: theme.dispatchPanelHeaderColor,
    letterSpacing: "1.5px",
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  searchRow: {
    display: 'flex',
    alignItems: 'center'
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    padding: 0
  },
  expandOpen: {
    transform: 'rotate(180deg)',
    padding: 0
  },
  expandIcon: {
    color: theme.iconColor,
    height: 30,
    width: 30
  }
});

export default styles;
